var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7543 6.62L20.9443 7.24L15.4943 11.97L17.1243 19L10.9443 15.27L4.76434 19L6.40434 11.97L0.944336 7.24L8.13434 6.63L10.9443 0L13.7543 6.62ZM7.18434 15.67L10.9443 13.4L14.7143 15.68L13.7143 11.4L17.0343 8.52L12.6543 8.14L10.9443 4.1L9.24434 8.13L4.86434 8.51L8.18434 11.39L7.18434 15.67Z",
    fill: "#D6DEE1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStar);
export default __webpack_public_path__ + "static/media/empty-star.8da1f7a3a40a20e13b0c24eef1244c04.svg";
export { ForwardRef as ReactComponent };